<template>
    <div :class="cardClass" @click="isSelectionAllowed && selectionChanged(ancillary.id)">
        <!-- Grid View -->
        <template v-if="viewType === 'grid'">
            <div class="card-header">
                <div class="info">
                    <div class="name-row">
                        <practice-card-new :practice="ancillary" :showInvitedDate="showInvitedDate"></practice-card-new>

                        <div class="tags">
                            <div class="main-name-row">
                                <h3>{{ ancillary?.name }}</h3>
                                <span class="verified">
                                    <common-icon name="verify" size="small"></common-icon>
                                    {{ $t('pages.network.connections.network_profile_detail.verify') }}
                                </span>
                                <span v-if="ancillary?.rating" class="rating">
                                    <common-icon name="star" size="small"></common-icon>
                                    <span class="rating-count">
                                        {{ ancillary?.rating || 0 }}
                                    </span>
                                    <span class="check"><common-icon name="check" size="small"></common-icon></span>
                                </span>
                            </div>

                            <p
                                v-if="ancillary?.facilityServiceGroups && ancillary.facilityServiceGroups.length > 0"
                                class="clinic"
                            >
                                {{ ancillary.facilityServiceGroups[0].name }}
                            </p>
                            <span class="tag">
                                <span class="check"><common-icon name="check" size="small"></common-icon></span>
                                {{ $t('pages.network.connections.network_profile_detail.board') }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <p v-if="IsInfacilityServiceTypesSubgroups" class="speciality">
                    {{ IsInfacilityServiceTypesSubgroups }}
                </p>

                <p v-if="ancillaryCity" class="location">
                    <common-icon name="location" size="small"></common-icon>
                    {{ ancillaryCity }} {{ ancillaryState }}
                    <span v-if="ancillary?.phone" class="inline-phone inline-phone--desktop">
                        •
                        <common-icon name="phones" size="small"></common-icon>
                        {{ ancillary.phone }}
                    </span>
                </p>

                <p v-if="isInMyNetwork" class="connections">
                    {{ ancillary?.connectionCount }}
                    {{ $t('pages.network.connections.network_profile_detail.connection') }}
                </p>

                <network-inlusion-status
                    v-if="showNetworkInclusionStatus"
                    :isInMyNetwork="isInMyNetwork"
                    targetType="practice"
                    :targetId="ancillary.id"
                    :provider="ancillary"
                    @added-to-network="emitEvent({ name: 'added-to-network' })"
                ></network-inlusion-status>
            </div>
            <div class="card-footer">
                <common-button
                    icon="refer"
                    class="refer-btn"
                    :label="$t('pages.network.connections.buttons.refer')"
                    size="large"
                    type="primary"
                    @click="itemClicked()"
                ></common-button>
                <div class="actions">
                    <common-button
                        v-if="ancillary?.email"
                        icon="chat"
                        class="icon-btn"
                        size="small"
                        type="info"
                        @click="toggleshowEmailForm()"
                    ></common-button>
                    <common-button
                        v-if="ancillary?.phone"
                        icon="phones"
                        class="icon-btn icon-btn--phone-mobile"
                        size="small"
                        type="info"
                        @click="makeCall"
                    ></common-button>
                </div>
            </div>
        </template>

        <!-- List View -->
        <template v-else>
            <div class="card-header">
                <div class="info">
                    <div class="name-row">
                        <practice-card-new :practice="ancillary" :showInvitedDate="showInvitedDate"></practice-card-new>

                        <div class="tags">
                            <div class="name-row">
                                <h3>{{ ancillary?.name }}</h3>
                                <span class="verified">
                                    <common-icon name="verify" size="small" style="width: 12px"></common-icon>
                                    {{ $t('pages.network.connections.network_profile_detail.verify') }}
                                </span>
                            </div>

                            <p
                                v-if="ancillary?.facilityServiceGroups && ancillary.facilityServiceGroups.length > 0"
                                class="clinic"
                            >
                                {{ ancillary.facilityServiceGroups[0].name }}
                            </p>
                            <p v-if="IsInfacilityServiceTypesSubgroups" class="speciality">
                                {{ IsInfacilityServiceTypesSubgroups }}
                            </p>
                            <div class="name-row">
                                <p v-if="ancillaryCity" class="location">
                                    <common-icon name="location" size="small"></common-icon>
                                    {{ ancillaryCity }} {{ ancillaryState }}
                                    <span>•</span>
                                </p>
                                <p v-if="isInMyNetwork" class="connections">
                                    {{ ancillary?.connectionCount }}
                                    {{ $t('pages.network.connections.network_profile_detail.connection') }}
                                </p>
                                <p v-else class="connections">
                                    {{ $t('elements.network.network_inclusion_status.buttons.add_to_my_network') }}
                                </p>
                            </div>
                            <div class="name-row">
                                <p v-if="ancillary?.phone" class="location inline-phone-row inline-phone-row--desktop">
                                    <common-icon name="phones" size="small"></common-icon>
                                    {{ ancillary.phone }}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="card-footer">
                        <span class="rating">
                            <div v-if="ancillary?.rating">
                                <common-icon name="star" size="small"></common-icon>
                                <span class="rating-count">
                                    {{ ancillary?.rating || 0 }}
                                </span>
                                <span class="check"><common-icon name="check" size="small"></common-icon></span>
                            </div>
                        </span>
                        <div class="actions">
                            <common-button
                                icon="refer"
                                class="refer-btn"
                                :label="$t('pages.network.connections.buttons.refer')"
                                size="small"
                                type="primary"
                                @click="itemClicked()"
                            ></common-button>
                            <common-button
                                v-if="ancillary?.email"
                                icon="chat"
                                class="icon-btn"
                                size="small"
                                type="info"
                                @click="toggleshowEmailForm()"
                            ></common-button>
                            <common-button
                                v-if="ancillary?.phone"
                                icon="phones"
                                class="icon-btn icon-btn--phone-mobile"
                                size="small"
                                type="info"
                                @click="makeCall"
                            ></common-button>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <direct-referral
            v-if="isDirectReferralModalOpen"
            :activePracticeType="practiceType"
            :user="ancillary"
            :showAsInnerModal="showCardAvailabilityAsInnerModal"
            @location-selected="toggleModal"
            @close="toggleModal"
        ></direct-referral>
        <common-modal v-if="showEmailForm" @close="closeSendNetworkMessageModal()">
            <email-form
                headerText="Send email"
                :defaultUser="ancillary"
                :showBccWarning="true"
                :showOpenSelectMemberModalButton="true"
                @email-data="sendEmail"
                @close="toggleshowEmailForm()"
            ></email-form>
        </common-modal>
    </div>
</template>

<script>
    import PracticeCardNew from 'components/page-elements/practice/PracticeCardNew'
    import DirectReferral from 'components/page-elements/referrals/DirectReferral'
    import NetworkInlusionStatus from 'components/page-elements/network/NetworkInlusionStatus'
    import PracticeTypeEnum from '@/enums/PracticeTypeEnum'
    import EmailForm from '../../forms/connections/EmailForm.vue'

    export default {
        components: {
            EmailForm,
            PracticeCardNew,
            DirectReferral,
            NetworkInlusionStatus,
        },

        props: {
            ancillary: { type: Object, default: undefined },
            isStandalone: { type: Boolean, default: true },
            isFixedHeight: { type: Boolean, default: true },
            showCardAvailability: { type: Boolean, default: true },
            showNetworkInclusionStatus: { type: Boolean, default: false },
            showInvitedDate: { type: Boolean, default: false },
            showCardAvailabilityAsInnerModal: { type: Boolean, default: false },
            checkedValues: { type: Array, default: () => [] },
            isSelectionAllowed: { type: Boolean, default: false },
            viewType: { type: String, required: true },
        },

        data() {
            return {
                showEmailForm: false,
                isDirectReferralModalOpen: false,
                practiceType: PracticeTypeEnum.ANCILLARY,
            }
        },

        computed: {
            cardClass() {
                const isGrid = this.viewType === 'grid'
                return {
                    card: isGrid,
                    'card-layout': !isGrid,
                    'card--is-selected': this.checked && isGrid,
                    'card--is-selectable': this.isSelectionAllowed && isGrid,
                    'card-layout--is-selected': this.checked && !isGrid,
                    'card-layout--is-selectable': this.isSelectionAllowed && !isGrid,
                }
            },
            ancillaryCity() {
                return this.ancillary?.city || this.ancillary?.locations?.[0]?.city || null
            },
            ancillaryState() {
                return this.ancillary?.state || this.ancillary?.locations?.[0]?.state || null
            },
            isInMyNetwork() {
                return this.ancillary.isInMyNetwork !== undefined ? this.ancillary.isInMyNetwork : true
            },
            checked() {
                return this.checkedValues.includes(this.ancillary?.id)
            },
            IsInfacilityServiceTypesSubgroups() {
                return (
                    this.ancillary?.facilityServiceGroups?.find((group) =>
                        group.facilityServiceTypesGroups?.some((typeGroup) =>
                            typeGroup.facilityServiceTypesSubgroups?.some((sub) => sub),
                        ),
                    )?.name || false
                )
            },
        },
        methods: {
            selectionChanged(id) {
                this.$emit('selection-changed', id)
            },
            sendEmail(event) {
                let bcc = []
                event.to.forEach((user) => {
                    bcc.push(user)
                })
                bcc.splice(event.to, 1)
                window.open(
                    `mailto:${event.to[0]}?bcc=${bcc || ''}&cc=${event.cc || ''}&subject=${event.subject}&body=${
                        event.message
                    }&from=${event.from}`,
                    '_blank',
                )
            },
            toggleshowEmailForm() {
                this.showEmailForm = !this.showEmailForm
            },
            closeSendNetworkMessageModal() {
                this.showEmailForm = false
            },
            toggleModal() {
                this.isDirectReferralModalOpen = !this.isDirectReferralModalOpen
            },
            itemClicked() {
                this.toggleModal()
            },
            makeCall() {
                if (!this.ancillary?.phone) return
                window.location.href = `tel:${this.ancillary.phone}`
            },
        },
    }
</script>
<style scoped lang="scss">
    @import 'styles/components/network/_network';

    .inline-phone,
    .inline-phone-row {
        color: inherit;
        white-space: nowrap;
        margin-left: 2px;
        display: inline-flex;
        align-items: center;
        gap: 6px;
    }

    .icon-btn--phone-mobile {
        display: none;
    }

    .inline-phone--desktop,
    .inline-phone-row--desktop {
        display: inline-flex;
    }

    .card {
        border-radius: 16px;
    }

    .card-body .network-inclusion-status {
        margin-top: 12px;
        display: flex;
        justify-content: center;
        padding: 0 16px;
    }

    @media (max-width: 767px) {
        .icon-btn--phone-mobile {
            display: inline-flex;
        }

        .inline-phone--desktop,
        .inline-phone-row--desktop {
            display: none;
        }
    }
</style>
